import { render, staticRenderFns } from "./vpnDownload.vue?vue&type=template&id=6aa60cdd&scoped=true"
import script from "./vpnDownload.vue?vue&type=script&lang=js"
export * from "./vpnDownload.vue?vue&type=script&lang=js"
import style0 from "./vpnDownload.vue?vue&type=style&index=0&id=6aa60cdd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa60cdd",
  null
  
)

export default component.exports